export default __webpack_public_path__ + "static/media/creative-process.53248ff1.png";